module.exports = __webpack_public_path__ + "static/media/shampoo.3ac7eb42.svg";